var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OverlayWrapper, StyledButton, UnstyledButton } from './styles';
import { LoadingSpinner } from '../LoadingSpinner';
var Button = function (_a) {
  var loading = _a.loading,
    _b = _a.role,
    role = _b === void 0 ? 'primary' : _b,
    _c = _a.size,
    size = _c === void 0 ? 'normal' : _c,
    _d = _a.inverted,
    inverted = _d === void 0 ? false : _d,
    _e = _a.overlay,
    overlay = _e === void 0 ? false : _e,
    _f = _a.type,
    type = _f === void 0 ? 'button' : _f,
    children = _a.children,
    rest = __rest(_a, ["loading", "role", "size", "inverted", "overlay", "type", "children"]);
  if (role === 'unstyled') return _jsx(UnstyledButton, __assign({
    overlay: overlay,
    type: type,
    "data-overlay": overlay
  }, rest, {
    children: children
  }));
  return _jsxs(StyledButton, __assign({
    "data-role": role,
    size: size,
    inverted: inverted,
    overlay: overlay,
    type: type,
    "data-overlay": overlay
  }, rest, {
    children: [loading ? _jsx(LoadingSpinner, {
      size: "2"
    }) : null, children]
  }));
};
Button.OverlayWrapper = OverlayWrapper;
export { Button };